import { render, staticRenderFns } from "./field-label.vue?vue&type=template&id=10318e2c&"
import script from "./field-label.vue?vue&type=script&lang=js&"
export * from "./field-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports